<template>
  <div class="toolbar-icon" :title="$t('title.commentTitle')" @click="addEditComment">
    <custom-icon :class-name="computedclassName" />
  </div>
</template>
<script>
import { icons } from "../../../utils/icons";
import DesignerMixin from "../DesignerMixin";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  mixins: [DesignerMixin],
  data() {
    return {
      icons: icons,
    };
  },
  computed: {
    computedclassName() {
      return this.edit ? icons.EditComment : icons.AddComment;
    },
    edit() {
      const activeCell =
        (this.activeCellId && this.mergedCellIds[this.activeCellId]
          ? this.cellsMetaData[this.mergedCellIds[this.activeCellId].replace("_merged", "")]
          : this.cellsMetaData[this.activeCellId]) || {};
      return "comment" in activeCell ?? "";
    },
  },
  methods: {
    addEditComment() {
      if (this.edit) this.editComment();
      if (this.activeCellId && !this.edit) this.$store.dispatch("cells/addComment");
    },
    editComment() {
      const cellId = this.mergedCellIds[this.activeCellId]
        ? this.mergedCellIds[this.activeCellId].replace("_merged", "")
        : this.activeCellId;
      this.$store.dispatch("cells/setComment", { id: cellId, editMode: true });
    },
    callFunc() {
      this.addEditComment();
    },
  },
};
</script>
